// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"69fb27ae","143":"1547a71b","359":"fb04a642","386":"a40611bf","411":"a8eda30d","555":"36eb9467","563":"2d9879b1","952":"356f2ca6"}[chunkId] + ".chunk.js";
};